export const generateGuides = (t) => [
  {
    id: 1,
    image: (
      <img
        className="claiming-guides-img"
        src="/assets/images/machineNumber.png"
        alt="machine number"
      />
    ),
    content: (
      <div className="claiming-guides-paragraph">
        <h5>{t('guides.materialNumber.title')}</h5>
        <h5>{t('guides.materialNumber.description')}</h5>
      </div>
    )
  },
  {
    id: 2,
    image: (
      <img
        className="claiming-guides-img"
        src="/assets/images/serialNumber.png"
        alt="serial number"
      />
    ),
    content: (
      <div className="claiming-guides-paragraph">
        <h5>{t('guides.serialNumber.title')}</h5>
        <h5>{t('guides.serialNumber.description')}</h5>
      </div>
    )
  },
  {
    id: 3,
    image: (
      <img
        className="claiming-guides-img"
        src="/assets/images/KIRAB50HMI.jpeg"
        alt="claiming code"
      />
    ),
    content: (
      <div className="claiming-guides-paragraph">
        <h5>{t('guides.claimingCode.title')}</h5>
        <h5>{t('guides.claimingCode.description')}</h5>
      </div>
    )
  }
];
